module.exports = __webpack_public_path__ + "static/media/AirTractor-AsaDireita.6b0050ab.png";